// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"checkbox_checkboxContainer__0I-3c","checkbox":"checkbox_checkbox__V3fMO","checked":"checkbox_checked__OTt8c","label":"checkbox_label__KqQnL"};